import React from 'react';
import { cn } from '@/utils/cn';
import Text from '../Text';
import Icon from '../Icon';

function FreeDelivery({ className = '', showRestContent = false }) {
  return (
    <div className="w-max bg-brilliant-white2 flex items-center gap-0.5 lg:gap-[4px] px-4 lg:px-10 py-4 rounded-[100px]">
      <Icon type="pickup-van" className="size-[16px] lg:size-[20px]" />
      <Text
        type="paragraph"
        className={cn(
          '!text-10 lg:!text-14 text-coarse-wool font-medium leading-14 lg:leading-20 tracking-[0.20px] lg:tracking-[0.28px] whitespace-pre',
          className,
        )}
      >
        Free {showRestContent ? 'Delivery' : null}
      </Text>
    </div>
  );
}

export default FreeDelivery;
